<template>
  <div class="h-full overflow-y-auto clearfix news-list">
    <div
      class="h-40px flex items-center justify-between bg-$portalPrimaryBgColor pl-20px pr-10px float-left"
      v-for="(item, index) in list"
      :key="item.id"
      :class="{
        'mb-10px': index !== list.length - 1,
        'mr-20px': (index + 1) % col !== 0,
      }"
      :style="{
        width: `calc(100% / ${col} - 20px * ${col - 1} / ${col})`,
      }"
    >
      <div
        class="text-18px text-$portalPrimaryColor font-bold flex-1 mr-10px truncate"
        :title="item.title"
      >
        {{ item.title }}
      </div>
      <div
        class="text-14px text-[#666] cursor-pointer"
        @click="loadMore(item)"
        v-if="data.showMore && !specialSource.includes(data.dataSource)"
      >
        更多
      </div>
    </div>
  </div>
</template>

<script>
import { ColumnTableSearchApi } from '@wiz-api/workbench-std'
import dayjs from 'dayjs'
import addRequestQueue from '@/assets/js/RequestQueue'

const columnTableSearchApi = new ColumnTableSearchApi()
export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: 'update',
    },
  },
  data() {
    return {
      list: [],
      row: 5,
      col: 1,
      specialSource: [
        '11111111-1111-1111-1111-111111111111',
        '22222222-2222-2222-2222-222222222222',
      ],
    }
  },
  computed: {
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    async getListData() {
      let params = {}
      if (this.data.dataSource === '22222222-2222-2222-2222-222222222222') {
        params = {
          columnId: this.data.columnId,
          ignoreId: this.data.columnTableId,
        }
      } else {
        params = {
          columnId: this.data.dataSource,
        }
      }
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearchApi.searchColumnTable(1, this.col * this.row, params)
      })
      if (!err) {
        this.list = res.items
        this.$nextTick(() => {
          this.$emit('nextTick')
        })
      }
    },
    async getHotListData() {
      const [err, res] = await addRequestQueue(() => {
        return columnTableSearchApi.getHotColumnTable(1, this.row * this.col, {
          hotStartTime: dayjs()
            .subtract(7, 'days')
            .format('YYYY-MM-DD HH:mm:ss'),
          hotEndTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        })
      })
      if (!err) {
        this.list = res.items
        this.$nextTick(() => {
          this.$emit('nextTick')
        })
      }
    },
    loadMore(item) {
      if (this.mode !== 'update') {
        if (item.externalLink) {
          window.open(item.externalLink)
        } else {
          window.open(
            `${window.location.origin}${window.location.hash ? '/#' : ''}${
              this.routerBase
            }/integration/portal/ColumnDetail?id=${item.id}&type=${item.type}`
          )
        }
      }
    },
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      async handler(val, oldVal) {
        if (!_.isEmpty(val) && val.dataSource) {
          this.row = val.row || 5
          this.col = val.col || 1
          if (
            val.dataSource !== oldVal?.dataSource ||
            this.col * this.row !== oldVal?.col * oldVal?.row
          ) {
            if (val.dataSource === '11111111-1111-1111-1111-111111111111') {
              this.getHotListData()
            } else {
              await this.getListData()
            }
          }
        }
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.clearfix {
  *zoom: 1;
  &::after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
}
</style>
